import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // **Check if we're in supplier portal**
  const isSupplierPortal = location.pathname.includes('/supplier/portal/') || 
                           location.pathname.includes('/supplier/article/');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* **Only show admin navbar when NOT in supplier portal** */}
      {!isSupplierPortal && <Navbar />}
      
      <main className={`flex-1 overflow-auto ${!isSupplierPortal ? 'pt-0' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default Layout;